import { TabPanel } from 'primereact/tabview';
import React, { useRef } from 'react';
import CardSeplag from '../../../components/cardSeplag/CardSeplag';
import Pages from '../../../config/Pages';
import ConfirmDialog from '../../../core/components/ConfirmDialog';
import Multipage from '../../../core/components/Multipage';
import EstruturaIndicador, {
    indicadorNavItems,
} from '../components/estruturaIndicador/EstruturaIndicador';
import styles from './MetasResultados.module.scss';
import ApuracaoResultado from './tabs/apuracaoResultado/ApuracaoResultado';
import ModalApurarResultado from './tabs/apuracaoResultado/components/modalApurarResultado/ModalApurarResultado';
import AvaliacaoResultadoList from './tabs/avalicaoResultado/AvaliacaoResultadoList';
import MetasList from './tabs/meta/MetasList';

function MetasResultados() {
    const modalApuracaoRef = useRef(null);
    const confirmOkRef = useRef(null);
    const confirmRef = useRef(null);

    return (
        <EstruturaIndicador selected={indicadorNavItems.metasResultados}>
            <ConfirmDialog isOk ref={confirmOkRef} />
            <ConfirmDialog ref={confirmRef} />
            <ModalApurarResultado ref={modalApuracaoRef} />
            <CardSeplag title={Pages.sei.metasResultados.title} legenda={() => ''}>
                <Multipage
                    className={styles.multipage}
                    initialData={{ modalApuracaoRef, confirmOkRef, confirmRef }}
                >
                    <TabPanel header={Pages.sei.metasResultados.tabs.metas}>
                        <MetasList />
                    </TabPanel>
                    <TabPanel header={Pages.sei.metasResultados.tabs.apuracaoResultado}>
                        <ApuracaoResultado />
                    </TabPanel>
                    <TabPanel header={Pages.sei.metasResultados.tabs.avaliacaoResultado}>
                        <AvaliacaoResultadoList />
                    </TabPanel>
                </Multipage>
            </CardSeplag>
        </EstruturaIndicador>
    );
}

export default MetasResultados;
